(ns practitest.frontend.active-sessions.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::init-complete?
 (fn [db _]
   (get-in db [:active-sessions :init-complete?])))

(re-frame/reg-sub
 ::get-all-sessions
 (fn [db _]
   (get-in db [:active-sessions :sessions] [])))

(re-frame/reg-sub
 ::total-licenses
 (fn [db _]
   (get-in db [:active-sessions :total-licenses])))

(re-frame/reg-sub
 ::used-licenses
 (fn [db _]
   (get-in db [:active-sessions :used-licenses])))
